module.exports = __webpack_public_path__ + "img/20200717_174826.e0900a7d.jpg";